import React from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/enlive.css';

const container = document.getElementById('root' );

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN!}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
        authorizationParams={{
          redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: process.env.REACT_APP_AUTH0_SCOPE
        }}
      >
        <App />
      </Auth0Provider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found.');
}
